export default __webpack_public_path__ + "static/media/frontpage.c09676b0.txt";